export class Details {
  description: string | null = null;
  screen: string | null = null;
}
